// extracted by mini-css-extract-plugin
export default {"container":"bK-z","topReviewHeading":"cK-z","criticalReview":"dK-z","favorableReview":"eK-z","vsSeparator":"fK-z"};